import { render, staticRenderFns } from "./ApiIntegration.vue?vue&type=template&id=1d3152c6&"
import script from "./ApiIntegration.vue?vue&type=script&lang=js&"
export * from "./ApiIntegration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports